import axios from "axios";
import { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { AiOutlineSearch } from "react-icons/ai";
import { SubTitle } from "../../Components/CustomComponents";
import DeleteModal from "../../Components/Modals/DeleteModal";
import Table from "../../Components/Table/Table";
import Toast from "../../Hooks/useToast";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

//
import { Dropdown } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ModalImage from "react-modal-image";
import { useDispatch } from "react-redux";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import ChangePasswordModal from "../../Components/Modals/changePassModal";
import { updateUsers } from "../../Data/features/userSlice";
import {
  useBlockUserMutation,
  useChangeUserPassMutation,
  useGetAllUsersQuery,
  useUnBlockUserMutation,
} from "../../Data/services/userApi"; // get data from API Servers

const UserManagementScreen = ({ setPage }) => {
  const [blockModal, setBlockModal] = useState(false);
  const [changePassModal, setChangePassModal] = useState(false);

  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      searchText: "", // or any sensible default
    },
  });
  const searchText = watch("searchText");
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [currentPage, setCurrentPage] = useState(1); // todo

  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllUsersQuery(
      {
        limit: pageSize,
        page: currentPage,
        search: searchText,
      },
      { refetchOnMountOrArgChange: true }
    );

  const [
    unblockUser,
    {
      isSuccess: isSuccessUnblock,
      isLoading: isLoadingUnblock,
      isError: isErrorUnblock,
    },
  ] = useUnBlockUserMutation();
  const [
    blockUser,
    {
      isSuccess: isSuccessBlock,
      isLoading: isLoadingBlock,
      isError: isErrorBlock,
    },
  ] = useBlockUserMutation();
  const [
    changeUserPass,
    {
      isSuccess: isSuccessChangePass,
      isLoading: isLoadingChangePass,
      isError: isErrorChangePass,
    },
  ] = useChangeUserPassMutation();

  // console.log(`userData = ${userData}`);
  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data?.links?.per_page);
      setCurrentPage(data?.links?.current);
      setTotalRecords(data?.links?.total_records);
      setTotalPages(data?.links?.total);
      setRowData(data?.data);
    }
    if (data?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [data]);

  useEffect(() => {
    if (data && isSuccess) {
      // console.log("isSuccess = " + data.users);
      dispatch(updateUsers(data.users));
    }
  }, [isSuccess, data, dispatch]);

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const deleteData = (id) => {
    console.log(id);
    axios(`https://jsonplaceholder.typicode.com//posts/${id}`)
      .then((res) => {
        // console.log(res.data)
        // console.log(res.status)
        // setData(res.data);
        if (res.status === 200) {
          Toast("Deleted Successfully", "success");
          handleDeleteModalClose();
        }
      })
      .catch((e) => {
        console.log(e);
        console.log(e.message);
        Toast("Something went wrong.", "error");
        // handleDeleteModalClose();
        // setIndicationMessage("Something went wrong, refresh again");
      });
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  // useEffect(() => {
  //   getData();
  //   return () => { };
  // }, []);

  // const getData = () => {
  //   // axios('https://jsonplaceholder.typicode.com/comments').then((res) => {
  //   axios("https://jsonplaceholder.typicode.com/users")
  //     .then((res) => {
  //       // console.log(res.data)
  //       // console.log(res.status)
  //       setIndicationMessage("");

  //       setData(res.data);

  //       setData((prv) => [...prv, res.data]); // todo:

  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setIndicationMessage("Something went wrong, refresh again");
  //     });
  // };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "profileImage",
      text: "Image",
      // sort: true,
      headerStyle: {
        width: "100px",
        height: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <ModalImage
            small={row?.image_url ? row?.image_url : "/images/placeholder.png"}
            large={row?.image_url ? row?.image_url : "/images/placeholder.png"}
            alt=""
            className="height-modal-image"
            // className={`image-fluid object-fit-contain rounded-circle ${
            //   viewImage ? "view-image" : "small-image"
            // }`}
            // onClick={() => setViewImage(true)}
          />
        );
      },
    },
    {
      dataField: "username",
      text: "Name",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return `${row?.first_name} ${row?.last_name}`;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerStyle: {
        width: "300px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
        textAlign: "center",
      },
      formatter: (cellContent, row) =>
        row?.is_blocked ? (
          <div className={styles.block}>Block</div>
        ) : (
          <div className={styles.active}> Active </div>
        ),
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row?.slug) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <Dropdown className={`d-inline mx-2 ${styles.choice}`}>
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="primary-btn"
                >
                  {/* <IoEllipsisVertical /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setBlockModal(true);
                    }}
                  >
                    {row?.is_blocked === true ? "UnBlock" : "Block"}
                  </Dropdown.Item>
                  {/* <Dropdown.Item href="#" onClick={() => handleUnBLockUser(row)}>UnBlock</Dropdown.Item> */}
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setChangePassModal(true);
                    }}
                  >
                    Change Password
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        }
      },
    },
  ];

  const onChangePassSubmit = async (data) => {
    try {
      let response = await changeUserPass({
        id: editedData?.slug,
        data: data,
      }).unwrap();
      Toast(response?.message, "success");
      setChangePassModal(false);
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const blockUnblockSubmit = async () => {
    let response;
    try {
      if (editedData?.is_blocked == true) {
        response = await unblockUser(editedData?.slug).unwrap();
      }
      if (editedData?.is_blocked == false) {
        response = await blockUser(editedData?.slug).unwrap();
      }

      Toast(response?.message, "success");
      setBlockModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const handleBlockModalClose = () => {
    setBlockModal(false);
    setEditedData("");
  };
  return (
    <div className={styles.MainContainer}>
      {changePassModal ? (
        <ChangePasswordModal
          handleModalClose={() => setChangePassModal(false)}
          onSubmit={onChangePassSubmit}
          isLoading={isLoadingChangePass}
        />
      ) : (
        ""
      )}
      {blockModal ? (
        <DeleteModal
          handleDeleteModalClose={handleBlockModalClose}
          data={editedData}
          cnfrmtext={
            editedData?.is_blocked === true ? "Unblock User" : "Block User"
          }
          text={editedData?.is_blocked === true ? "Unblock" : "Block"}
          cnfrm={isLoadingBlock ? <LoadingButton /> : "Confirm"}
          cancel={"Cancel"}
          onDelete={blockUnblockSubmit}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div className="w-100 flex-between">
          <SubTitle text={"User Management"} />
          <div className="d-flex gap-5">
            <div className={styles.search}>
              <div className={styles.searchButton}>
                <AiOutlineSearch color="black" />
              </div>
              <Controller
                control={control}
                name="searchText"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value || ""} // Ensure empty string fallback
                    ref={ref}
                  />
                )}
              />
            </div>
          </div>
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        <Table
          data={rowData}
          columns={columns}
          indication={indication}
          totalRecords={totalRecords} // todo
          totalPages={totalPages} // todo
          pageSize={pageSize} // todo
          currentPage={currentPage} // todo
          setCurrentPage={setCurrentPage} // todo
          setPageSize={setPageSize} // todo
          refetch={refetch} // todo
        />
      </div>
    </div>
  );
};

export default UserManagementScreen;
